const publicAuthRoutes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/components/Login.vue"),
    meta: { publicAuth: true },
  },
  {
    path: "/register",
    name: "Registration",
    component: () => import("@/components/auth/RegistrationWizard.vue"),
    meta: { publicAuth: true },
  },
  {
    path: "/verify-email",
    name: "VerifyEmail",
    component: () => import("@/components/auth/VerifyEmailPage.vue"),
    meta: { publicAuth: true },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: () => import("@/components/auth/ForgotPasswordPage.vue"),
    meta: { publicAuth: true },
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: () => import("@/components/auth/ResetPasswordPage.vue"),
    meta: { publicAuth: true },
  },
  {
    path: "/link-google",
    name: "GoogleLink",
    component: () => import("@/components/auth/GoogleLinkConfirmationPage.vue"),
    meta: { publicAuth: true },
  },
];

export default publicAuthRoutes;
